import type { Player } from 'modules/client/tournaments/domain/types';
import type { ChampionshipApplicationDto } from 'modules/client/tournaments/domain/types/dtos';

function playersMapper(championshipApplications: ChampionshipApplicationDto[]): Player[] {
  return championshipApplications.reduce((array, app) => {
    if (app.state === 'ACCEPTED' && !app.user.isReal) {
      array.push({
        id: app.user.id,
        name: [app.user.surname, app.user.name, app.user.middleName].filter(Boolean).join(' '),
        position: app.position,
        number: app.number,
        teamId: app.team.id,
        goals: 0,
        assists: 0,
        appearances: 0,
        redCards: 0,
        yellowCards: 0,
      } as Player);
    }

    return array;
  }, [] as Player[]);
}

export default playersMapper;
